import { render, staticRenderFns } from "./FaceContent.vue?vue&type=template&id=7d216e50&scoped=true&"
import script from "./FaceContent.vue?vue&type=script&lang=js&"
export * from "./FaceContent.vue?vue&type=script&lang=js&"
import style0 from "./FaceContent.vue?vue&type=style&index=0&id=7d216e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d216e50",
  null
  
)

export default component.exports